import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet } from '../hooks/useFleet';
import { useHasPermission } from '../hooks/useHasPermission';
import { UserProfileService } from '../services';
import { Fleet } from '../interfaces';
import { userGroup } from '../enums';

export const useAllUsers = () => {
  const queryKey = ['allUsers'];
  const hasPermission = useHasPermission('users:read:search');

  const queryFn = () => UserProfileService.searchUsers();

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!hasPermission,
  });
};

export const useUsers = () => {
  const fleet = useFleet();
  const hasPermission = useHasPermission('users:read:list');
  const queryKey = ['users', fleet.id];

  const queryFn = () => UserProfileService.getAll();

  return useQuery({
    queryKey,
    queryFn,
    enabled: hasPermission && !!fleet.id,
  });
};

export const useGroupMembers = (group: userGroup) => {
  const hasPermission = useHasPermission('users:read:list');
  const queryKey = ['groupUsers', group];

  const queryFn = () => UserProfileService.getUsersFromGroup(group);

  return useQuery({
    queryKey,
    queryFn,
    enabled: hasPermission,
  });
}

export const refreshUsers = (fleetId: Fleet['id']) => {
  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['users', fleetId]);
};
